import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useListInventoryCountsQuery } from '../../redux/api/inventoryApi';

const fmt = (iso) => new Date(iso).toLocaleString('de-DE');

const InventoryCountList = () => {
  const currentEvent = useSelector((state) => state.auth.currentEvent);
  const { data: counts, isLoading } = useListInventoryCountsQuery(
    currentEvent?.id,
    { skip: !currentEvent?.id }
  );

  if (!currentEvent?.id) {
    return <p className='mt-4'>Bitte zuerst ein Event auswählen.</p>;
  }

  if (isLoading) {
    return <p className='mt-4'>Inventuren werden geladen...</p>;
  }

  return (
    <div>
      <h4 className='mt-2'>Inventuren</h4>
      {!counts || counts.length === 0 ? (
        <p className='text-muted'>Noch keine Inventuren erfasst.</p>
      ) : (
        <table className='table table-striped mt-4 align-middle text-start'>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Erfasst von</th>
              <th>Notiz</th>
              <th className='text-end'>Positionen</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {counts.map((c) => (
              <tr key={c.id}>
                <td>{fmt(c.created_at)}</td>
                <td>{c.created_by_username || '—'}</td>
                <td>{c.note || '—'}</td>
                <td className='text-end'>{c.items?.length ?? 0}</td>
                <td>
                  <Link to={`/inventory-counts/${c.id}`}>Details</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default InventoryCountList;
